@if (resAsync | async) {
  <div class="containerStepper">
    <div fxLayout="column" fxLayoutAlign="center none">
      <div class="headerHelp" fxLayout="row" fxLayoutAlign="end none">
        <button
          id="selectHelpButton"
          mat-icon-button
          matTooltip="res.get('OpenHelpLink')"
          aria-label="res.get('SelectHelp')"
          (click)="openHelp()"
        >
          <mat-icon [svgIcon]="res.svgName('Help-Image')" class="helpIcon"></mat-icon>
        </button>
      </div>
      <div class="center">
        <mat-vertical-stepper #stepper [linear]="isLinear" (selectionChange)="stepSelectionChange($event)">
          <mat-step state="chat" [editable]="isEditable" [label]="res.get('WizardWelcome')">
            <div style="display: flex">
              <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 600px">
                <div>
                  <h1>{{ res.get('WorksGeneration') }}</h1>
                </div>
              </div>
            </div>
            <div fxLayout="row">
              <div fxLayoutAlign="center center">
                <p>
                  {{ res.get('WorksGenerationDescription') }}
                </p>
              </div>
            </div>
            <div class="generatorModeSelection">
              <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedGeneratorMode">
                <mat-radio-button value="cyclic">{{ res.get('GenerateCyclicWorks') }}</mat-radio-button>
                <mat-radio-button value="manual">{{ res.get('GenerateManualWorks') }}</mat-radio-button>
              </mat-radio-group>
            </div>
            <hr />
            <div fxLayout="row" style="float: right">
              <div fxFlex="30">
                <button mat-button matStepperNext>{{ res.get('ButtonTextContinue') }}</button>
              </div>
            </div>
          </mat-step>
          <mat-step
            #stepMainData
            [label]="res.get('LabelBaseData')"
            state="chat"
            [editable]="isEditable"
            completed="false"
          >
            <p>{{ res.get('BasicInformationWorks') }}</p>
            <div fxLayout="column" fxLayoutAlign="space-between start">
              <basys-opera-wizards-create-works-configuration
                #configurationComponent
                (workExecTimeSelection)="onWorkTypeIdChange($event)"
              >
              </basys-opera-wizards-create-works-configuration>
            </div>
            @if (selectedGeneratorMode === 'manual') {
              <div>
                <div fxLayout="row" fxLayout.sm="column" fxLayout.md="column" class="manualWorkSpacer">
                  <abc-date-box
                    #dateExecEarliest
                    [label]="res.get('ExecutionFrom')"
                    [labelMode]="'floating'"
                    [width]="'250px'"
                    [height]="'40px'"
                    [(value)]="manualEarliestExecDate"
                    (onChange)="onEarliestExecDateChanged($event)"
                    [acceptCustomValue]="false"
                    [openOnFieldClick]="true"
                  >
                  </abc-date-box>
                  <abc-date-box
                    #dateExecScheduled
                    [label]="res.get('ExecutionPlanned')"
                    [labelMode]="'floating'"
                    [width]="'250px'"
                    [height]="'40px'"
                    [(value)]="manualScheduledExecDate"
                    (onChange)="onScheduledExecDateChanged($event)"
                    [acceptCustomValue]="false"
                    [openOnFieldClick]="true"
                  >
                  </abc-date-box>
                  <abc-date-box
                    [label]="res.get('ExecutionTill')"
                    [labelMode]="'floating'"
                    [width]="'250px'"
                    [height]="'40px'"
                    (onChange)="onLatestExecDateChanged($event)"
                    [(value)]="manualLatestExecDate"
                    [acceptCustomValue]="false"
                    [openOnFieldClick]="true"
                  >
                  </abc-date-box>
                </div>
              </div>
            }
            <br />
            <hr />
            <div class="step-buttons">
              <button mat-button matStepperPrevious>{{ res.get('ButtonTextBack') }}</button>
              <button mat-button (click)="validateStep(stepMainData)">{{ res.get('ButtonTextContinue') }}</button>
            </div>
          </mat-step>
          <mat-step #stepObjectSelection state="chat" [editable]="isEditable" completed="false">
            <ng-template matStepLabel>{{ res.get('SelectAssets') }}</ng-template>
            <div style="height: 360px">
              <p>
                {{ res.get('SelectAssetsDescription') }}
              </p>
              @if (
                {
                  objectSelectionGroups: (objectSelectionGroups$ | async),
                  isLoadingGroups: (isLoadingGroups$ | async),
                };
                as objSelectionObservables
              ) {
                <div>
                  @if (!objSelectionObservables.isLoadingGroups && objSelectionObservables.objectSelectionGroups) {
                    @if (objSelectionObservables.objectSelectionGroups.length === 0) {
                      <div>
                        <div class="fullPageContainer" fxFill fxLayout="row" fxLayoutAlign="center center">
                          {{ res.get('ErrorAtSelectionOfAssetsCandidates') }}
                        </div>
                      </div>
                    }
                    @if (objSelectionObservables.objectSelectionGroups.length > 0) {
                      <div fxLayout="row" fxLayoutAlign="center center">
                        <div style="height: 300px">
                          <abc-object-selection-group
                            #groupSelectionComponent
                            [groups]="objSelectionObservables.objectSelectionGroups"
                            (itemsCount)="countAssets($event)"
                          >
                          </abc-object-selection-group>
                        </div>
                      </div>
                    }
                  } @else {
                    <div class="fullPageContainer" fxFill fxLayout="row" fxLayoutAlign="center center">
                      <dx-load-indicator ngClass="task-icon" ngClass.lt-sm="task-icon small"> </dx-load-indicator
                      >{{ res.get('AssetsWillBeLoaded') }}
                    </div>
                  }
                </div>
              }
            </div>
            <hr />
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <div class="items-count">
                <p>
                  {{ res.get('SelectedAssetsCount') }}: <span>{{ assetsCount() }}</span>
                </p>
              </div>
              <div class="step-buttons">
                <button mat-button matStepperPrevious>{{ res.get('ButtonTextBack') }}</button>
                <button mat-button (click)="validateStep(stepObjectSelection)">
                  {{ res.get('ButtonTextContinue') }}
                </button>
              </div>
            </div>
          </mat-step>
          <mat-step #stepAuftrag state="chat" [editable]="isEditable" completed="false">
            <ng-template matStepLabel>{{ res.get('OrderAssignment') }}</ng-template>
            <p>{{ res.get('OrderAssignmentDescription') }}</p>
            <div>
              <mat-radio-group
                #auftragTypes
                aria-label="Select an option"
                [(ngModel)]="selectedAuftragMode"
                (ngModelChange)="onAuftragModeChanged($event)"
              >
                <mat-radio-button value="none">{{ res.get('WithoutOrder') }}</mat-radio-button>
                <mat-radio-button value="useExisting">{{ res.get('AvlOrder') }}</mat-radio-button>
                <mat-radio-button value="createNew">{{ res.get('NewOrder') }}</mat-radio-button>
              </mat-radio-group>
            </div>
            <br />
            @if (selectedAuftragMode === 'useExisting') {
              <div style="width: 400px">
                <abc-drop-down-box
                  (onValueChanged)="onAuftragChanged($event)"
                  [label]="res.get('Order')"
                  [labelMode]="'floating'"
                  [width]="'400px'"
                  [height]="'40px'"
                  [dataSource]="auftragData"
                  displayExpr="Description"
                  valueExpr="Id"
                  [hideColumnHeaders]="true"
                  [gridColumns]="[
                    {
                      dataField: 'Description',
                      name: 'Description',
                    },
                  ]"
                ></abc-drop-down-box>
                <br />
              </div>
            }
            @if (selectedAuftragMode === 'createNew') {
              <div style="width: 584px" class="newOrderSpacer">
                <div fxLayout="row" fxLayoutGap="4px">
                  <abc-text-box
                    [label]="res.get('Designation')"
                    [labelMode]="'floating'"
                    [value]="''"
                    [width]="'400px'"
                    [height]="'40px'"
                    (onValueChanged)="onNewAuftragNameChanged($event)"
                    valueChangeEvent="keyup"
                  >
                  </abc-text-box>
                  <abc-text-box
                    [label]="res.get('Number')"
                    [labelMode]="'floating'"
                    [value]="''"
                    [width]="'180px'"
                    [height]="'40px'"
                    (onValueChanged)="onNumberChanged($event)"
                    valueChangeEvent="keyup"
                  >
                  </abc-text-box>
                </div>
                <abc-date-box
                  [label]="res.get('Date')"
                  [labelMode]="'floating'"
                  [width]="'250px'"
                  [height]="'40px'"
                  [(value)]="auftragsDate"
                  (onChange)="onAuftragDateChanged($event)"
                  [acceptCustomValue]="false"
                  [openOnFieldClick]="true"
                >
                </abc-date-box>
                <abc-drop-down-box
                  (onValueChanged)="onAuftragStatusChanged($event)"
                  [label]="res.get('OrderState')"
                  [labelMode]="'floating'"
                  [width]="'400px'"
                  [height]="'40px'"
                  [dataSource]="auftragStatusData"
                  displayExpr="Description"
                  valueExpr="Value"
                  [hideColumnHeaders]="true"
                  [gridColumns]="[
                    {
                      dataField: 'Description',
                      name: 'Description',
                    },
                  ]"
                ></abc-drop-down-box>
                <abc-text-box
                  [label]="res.get('Remark')"
                  [labelMode]="'floating'"
                  [value]="''"
                  [width]="'584px'"
                  [height]="'40px'"
                  (onValueChanged)="onRemarkChanged($event)"
                  valueChangeEvent="keyup"
                >
                </abc-text-box>
              </div>
            }
            <br />
            <hr />
            <div class="step-buttons">
              <button mat-button matStepperPrevious>{{ res.get('ButtonTextBack') }}</button>
              <button mat-button (click)="validateStep(stepAuftrag)">{{ res.get('ButtonTextContinue') }}</button>
            </div>
          </mat-step>
          @if (showResourcesStep()) {
            <mat-step
              #stepResourcesSelection
              [label]="res.get('ResourcesDetails')"
              state="chat"
              [editable]="isEditable"
            >
              <p>{{ res.get('BasicInformationResources') }}</p>
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" class="resource-options-bar">
                <span class="resource-options-label">
                  {{ res.get('ResourcesSelectionText') }}
                </span>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
                  <abc-check-box
                    class="resource-option-checkbox"
                    [text]="res.get('ChildResources')"
                    [(value)]="selectChildrenResources"
                    (onValueChanged)="onChildResourcesSelectionChange($event)"
                  ></abc-check-box>
                  <abc-check-box
                    class="resource-option-checkbox"
                    [text]="res.get('ReferencedResources')"
                    [(value)]="selectReferencedResources"
                    (onValueChanged)="onReferencedResourcesSelectionChange($event)"
                  ></abc-check-box>
                </div>
              </div>
              @if (
                {
                  anotherObjectSelectionGroups: (anotherObjectSelectionGroups$ | async),
                  isLoadingAnotherGroups: (isLoadingAnotherGroups$ | async),
                };
                as anotherObjSelectionObservables
              ) {
                <div>
                  @if (
                    !anotherObjSelectionObservables.isLoadingAnotherGroups &&
                    anotherObjSelectionObservables.anotherObjectSelectionGroups
                  ) {
                    @if (anotherObjSelectionObservables.anotherObjectSelectionGroups.length === 0) {
                      <div>
                        <div class="fullPageContainer" fxFill fxLayout="row" fxLayoutAlign="center center">
                          {{ res.get('ErrorAtSelectionOfAnotherAssetsCandidates') }}
                        </div>
                      </div>
                    }
                    @if (anotherObjSelectionObservables.anotherObjectSelectionGroups.length > 0) {
                      <div fxLayout="row" fxLayoutAlign="center center">
                        <div style="height: 300px; margin-bottom: 8px">
                          <abc-object-selection-group
                            #groupSelectionComponent2
                            [groups]="anotherObjSelectionObservables.anotherObjectSelectionGroups"
                            (selectedItemsCount)="countResources($event)"
                          >
                          </abc-object-selection-group>
                        </div>
                      </div>
                    }
                  } @else {
                    <div class="fullPageContainer" fxFill fxLayout="row" fxLayoutAlign="center center">
                      <dx-load-indicator ngClass="task-icon" ngClass.lt-sm="task-icon small"> </dx-load-indicator
                      >{{ res.get('AssetsWillBeLoaded') }}
                    </div>
                  }
                </div>
              }
              <hr />
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <div class="items-count">
                  <p>
                    {{ res.get('SelectedResourcesCount') }} <span> {{ resCount() }}</span>
                  </p>
                </div>
                <div class="step-buttons">
                  <button mat-button matStepperPrevious>{{ res.get('ButtonTextBack') }}</button>
                  <button mat-button matStepperNext (click)="validateData()">
                    {{ res.get('ButtonTextContinue') }}
                  </button>
                </div>
              </div>
            </mat-step>
          }
          <mat-step state="chat">
            <ng-template matStepLabel>{{ res.get('StepperTextCheckData') }}</ng-template>
            <p>{{ firstTitle() }}</p>
            @if (displayBusybar()) {
              <div>
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
            }
            <br />
            <div class="step-buttons">
              <button mat-button class="back-button" (click)="moveBack()" [disabled]="buttonStatus() || !isEditable">
                {{ res.get('ButtonTextBack') }}
              </button>
              <button
                mat-button
                matStepperNext
                (click)="isReadOnly() ? null : generateWorksWithProtocol()"
                [ngClass]="buttonClass"
                [disabled]="buttonStatus()"
              >
                <span>{{ textButton() }}</span>
              </button>
            </div>
          </mat-step>
        </mat-vertical-stepper>
      </div>
    </div>
  </div>
}
